import { render, staticRenderFns } from "./McmCopyIcon.vue?vue&type=template&id=6094e03b&scoped=true&"
import script from "./McmCopyIcon.vue?vue&type=script&lang=ts&"
export * from "./McmCopyIcon.vue?vue&type=script&lang=ts&"
import style0 from "./McmCopyIcon.vue?vue&type=style&index=0&id=6094e03b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6094e03b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
